export enum MapInventoryType {
  SITES = 'sites',
  UNITS = 'units',
}

export enum MapColors {
  PURPLE = '#CB25EF',
  CYAN = '#01E2E2',
  DARKCYAN = '#2FA6A6',
  BLUE = '#3776F6',
  BLACK = '#454545',
  GREEN = '#C4E248',
  WHITE = '#DDDDDD',
  PINK = '#FF0083',
}
